/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CheckAgencyForExistingAccountResult
 */
export interface CheckAgencyForExistingAccountResult {
    /**
     * 
     * @type {boolean}
     * @memberof CheckAgencyForExistingAccountResult
     */
    exist: boolean;
    /**
     * 
     * @type {string}
     * @memberof CheckAgencyForExistingAccountResult
     */
    accountEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckAgencyForExistingAccountResult
     */
    accountCompanyName?: string;
    /**
     * Populated when an agency exists on the same email domain but the provided email does not match any known account. Contains the main contact email of the existing agency so the client can be nudged toward the correct address. Null when the provided email is an exact match or when no agency account is found.
     * 
     * @type {string}
     * @memberof CheckAgencyForExistingAccountResult
     */
    suggestedContactEmail?: string;
}

/**
 * Check if a given object implements the CheckAgencyForExistingAccountResult interface.
 */
export function instanceOfCheckAgencyForExistingAccountResult(value: object): value is CheckAgencyForExistingAccountResult {
    if (!('exist' in value) || value['exist'] === undefined) return false;
    return true;
}

export function CheckAgencyForExistingAccountResultFromJSON(json: any): CheckAgencyForExistingAccountResult {
    return CheckAgencyForExistingAccountResultFromJSONTyped(json, false);
}

export function CheckAgencyForExistingAccountResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): CheckAgencyForExistingAccountResult {
    if (json == null) {
        return json;
    }
    return {
        
        'exist': json['exist'],
        'accountEmail': json['accountEmail'] == null ? undefined : json['accountEmail'],
        'accountCompanyName': json['accountCompanyName'] == null ? undefined : json['accountCompanyName'],
        'suggestedContactEmail': json['suggestedContactEmail'] == null ? undefined : json['suggestedContactEmail'],
    };
}

export function CheckAgencyForExistingAccountResultToJSON(value?: CheckAgencyForExistingAccountResult | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'exist': value['exist'],
        'accountEmail': value['accountEmail'],
        'accountCompanyName': value['accountCompanyName'],
        'suggestedContactEmail': value['suggestedContactEmail'],
    };
}

